<div class="appointment-overview">
    <h4>Afspraak schadevastelling</h4>

    <div class="appointment-overview__content" *ngIf="appointment.gebeurtenis">
        <div class="appointment-overview__item appointment-overview__item--smupped">
            <img
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/Shmuppet-schade-225x225.gif"
                class="image image--header"
                alt=""
            />
        </div>
        <div class="appointment-overview__item appointment-overview__item--details">
            <p class="appointment-overview__text">
                Gelukt! U heeft op
                <span>{{ appointment.gebeurtenis.schadeherstel_gebeurtenis_datum | dateFormat: "LL" }}</span>
                om
                <span>{{ appointment.gebeurtenis.schadeherstel_gebeurtenis_tijdstip | time }}</span>
                een afspraak bij:
            </p>
            <div class="radio-list__card-container radio-list__card-container--highlighted">
                <div class="radio-list__card-label">
                    <span class="radio-list__card-title">{{ appointment.gebeurtenis.naam }}</span>
                    <span class="radio-list__card-content">
                        <span class="radio-list__card-content-item">
                            {{ appointment.gebeurtenis.straatnaam }} {{ appointment.gebeurtenis.huisnummer }}
                        </span>
                        <span class="radio-list__card-content-item">
                            {{ appointment.gebeurtenis.postcode }} {{ appointment.gebeurtenis.plaatsnaam }}
                        </span>
                        <!--                        <span class="radio-list__card-content-item radio-list__card-content-item&#45;&#45;icon">-->
                        <!--                            <svg class="svg-icon svg-icon&#45;&#45;xs">-->
                        <!--                            <use href="assets/icons-ui.svg#location"></use>-->
                        <!--                        </svg>-->
                        <!--                            &lt;!&ndash; Todo: distance prop gebruiken zodra deze beschikbaar is &ndash;&gt;-->
                        <!--                            {{ 0 | kilometer }} km-->
                        <!--                        </span>-->
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
